import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import configureStore from './js/stores/store';
import { Provider } from 'react-redux';
import { Route, IndexRoute, Router, browserHistory } from 'react-router';
import App from './js/components/app';
import LandingPage from './js/components/home/landingPage';
import ServicesPage from './js/components/services/servicesPage';
import ServiceBlock from './js/components/services/serviceBlock';
import PortfolioPage from './js/components/portfolio/portfolioPage';
import PrivatePortfolioPage from './js/components/portfolio/privatePortfolioPage';
import PortfolioItem from './js/components/portfolio/portfolioItem';
import BlogPage from './js/components/blog/blogPage';
import BlogPostPage from './js/components/blog/blogPostPage';
import AboutPage from './js/components/about/aboutPage';
import TermsPage from './js/components/about/termsPage';
import BusinessTermsPage from './js/components/about/businessTermsPage';
import PrivacyPage from './js/components/about/privacyPage';
import ContactPage from './js/components/contact/contactPage';
import StartProjectPage from './js/components/contact/startProjectPage';
import LoginPage from './js/components/login';

import { loadServices, checkUser, pageChange, startTransition, endTransition } from './js/actions/siteActions';

import './styles/style.css';

let data = data || {};

const store = configureStore(data);

store.dispatch(loadServices());
store.dispatch(checkUser());

function onPageChange(prevState, nextState, replace, callback) {

    let ga = ga || '';

    if (ga) {
        ga('set', 'page', nextState.location.pathname);
        ga('send', 'pageview');
    }

    store.dispatch(pageChange(prevState.location.pathname, nextState.location.pathname, callback));

    if (prevState.location.pathname === '/' || nextState.location.pathname === '/') {
        store.dispatch(startTransition(true));
    } else {
        callback();
    }
}

let routes = (
    <Route path="/" component={App} onChange={onPageChange} >
        <IndexRoute component={LandingPage} />
        <Route path="services" component={ServicesPage}>
            <Route path=":id" component={ServiceBlock}>
                <Route path=":id" component={PortfolioItem} />
            </Route>
        </Route>
        <Route path="portfolio" component={PortfolioPage}>
            <Route path=":id" component={PortfolioItem} />
        </Route>
        <Route name="blog" path="/blog" component={BlogPage} />
        <Route path="blog/:id" component={BlogPostPage} />
        <Route path="about" component={AboutPage} />
        <Route path="about/ethos" component={AboutPage} />
        <Route path="about/history" component={AboutPage} />
        <Route path="about/team" component={AboutPage} />
        <Route path="about/careers" component={AboutPage} />
        <Route path="contact" component={ContactPage} />
        <Route path="terms" component={TermsPage} />
        <Route path="business-terms" component={BusinessTermsPage} />
        <Route path="privacy" component={PrivacyPage} />
        <Route path="start-project" component={StartProjectPage} />
        <Route path="private-login" component={LoginPage} />
        <Route path="private-portfolio" component={PrivatePortfolioPage} >
            <Route path=":id" component={PortfolioItem} />
        </Route>

    </Route>
);

render(
    <Provider store={store}>
        <Router history={browserHistory} routes={routes} />
    </Provider>,
    document.getElementById("app")
);



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/